import {useProductOptions} from '@shopify/hydrogen';
import OptionButton from '../../elements/OptionButton';
import clsx from 'clsx';

type Props = {
  name: string;
  values: {
    name: string;
    availableForSale: boolean;
  }[];
};

export default function ProductOptionsDefault({name, values}: Props) {
  const {setSelectedOption, selectedOptions} = useProductOptions();

  const handleChange = (optionName: string, optionValue: string) => {
    if (setSelectedOption) {
      setSelectedOption(optionName, optionValue);
    }
  };

  return (
    <div key={name} className="[&:not(:first-child)]:mt-20">
      <h2
        className="capitalize truncate mb-20"
        style={{gridArea: '1/1/2/2'}}
      >
        {name}
      </h2>
      <div className={clsx(
        'flex flex-wrap gap-5'
      )}>
        {values.map((value) => {
          const checked = selectedOptions?.[name] === value.name;
          const id = `option-${name}-${value.name}`;

          return (
            <label key={id} htmlFor={id}>
              <input
                className="sr-only"
                type="radio"
                id={id}
                name={`option[${name}]`}
                value={value.name}
                checked={checked}
                onChange={() => handleChange(name, value.name)}
              />
              <OptionButton checked={checked} label={value.name} availableForSale={value.availableForSale} />
            </label>
          );
        })}
      </div>
    </div>
  );
}
